import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ProductBase} from '../models/product.model';
import {PolicyTemplateListItem} from '../models/policy.model';
import {ProductCpi} from '../models/product-cpi.model';
import {DictionaryItem} from '../models/dictionary.model';
import {map} from 'rxjs/operators';

/*
 * reduce Product object size only to necessary data
 */
const parseProduct = (product) => {
    return {
        ...product,
        // kidFile & owuFile - store only needed values
        configuration: {
            ...product.configuration,
            kidFile: {
                id: product?.configuration?.kidFile?.id,
                documentName: product?.configuration?.kidFile?.documentName,
            },
            owuFile: {
                id: product?.configuration?.owuFile?.id,
                documentName: product?.configuration?.owuFile?.documentName,
            }
        }
    };
};

@Injectable()
export class ProductCpiService {
    baseUrl = '/api/secured/product/cpi';

    constructor(
        private http: HttpClient,
    ) {
    }

    getOne(productId: number) {
        return this.http.get<ProductCpi>(`${this.baseUrl}/${productId}`).pipe(map(parseProduct));
    }

    duplicate(id: number, data: ProductBase) {
        return this.http.post<ProductCpi>(`${this.baseUrl}/${id}/duplicate`, {...data});
    }

    add(data: ProductBase) {
        return this.http.post<ProductCpi>(this.baseUrl, {...data});
    }


    update(product: ProductCpi) {
        const {id, configuration, ...productData} = product; // do not send configuration for CPI
        return this.http.put<ProductCpi>(`${this.baseUrl}/${id}`, productData);
    }


    merge(product: ProductCpi) {
        return this.http.put<ProductCpi>(`${this.baseUrl}/${product?.id}/merge`, {
            hash: product?.configuration?.configurationFile?.hash,
            configurationNote: product?.configuration?.configurationNote
        }).pipe(map(parseProduct));
    }

    uploadFile(hash) {
        return this.http
            .post(`${this.baseUrl}/import?hash=${hash}`, {});
    }

    downloadFile(hash) {
        window.location.href = `${this.baseUrl}/download?hash=${hash}`;
    }

    getTemplates() {
        return this.http.get<PolicyTemplateListItem[]>(`${this.baseUrl}/templates`);
    }

    getStatusList(id: number) {
        return this.http.get<DictionaryItem[]>(`${this.baseUrl}/${id}/available-status`);
    }
}
